module.exports = __webpack_public_path__ + "img/foton100black.fb11c6c3.png";